class AccountSettings.TaxonomiesListView extends Backbone.View
  template: JST["backbone/templates/account_settings/taxonomies/list"]


  events:
    'click .edit-taxonomy': 'onClickEdit'
    'click .delete-taxonomy': 'onClickDelete'

  initialize: (@options = {}) ->
    @taxonomies = @options.taxonomies

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    taxonomyId = $(evt.currentTarget).data('id')
    taxonomy_to_edit = @taxonomies.get(taxonomyId)
    @trigger('edit', taxonomy_to_edit)

  onClickDelete: (evt) ->
    swal({
        title: I18n.t('monitoring.taxonomy.delete.msg')
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('monitoring.taxonomy.y')
        cancelButtonText: I18n.t('monitoring.taxonomy.n')
        closeOnConfirm: true
      }, =>
        taxonomyId = $(evt.currentTarget).data('id')
        taxonomyToDelete = @taxonomies.get(taxonomyId)
        taxonomyToDelete.destroy(
          success: (response) =>
            @taxonomies.remove(taxonomyToDelete)
            console.log("Deleted taxonomy #{taxonomyToDelete.get('name')}")
            @render()
          error: (response) =>
            console.log("Error deleting taxonomy #{taxonomyToDelete.get('name')}")
        )
    )
